var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleEarth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4481.832 4482.661",
    enableBackground: "new 0 0 4481.832 4482.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs34"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 1034.8246,
    cy: 4082.8464,
    r: 25.2971,
    gradientTransform: "matrix(176,0,0,-176,-181452.28,719258.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    },
    id: "stop22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    },
    id: "stop24"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g61"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#255fdb",
    d: "M 1545.47,2708.41 C 781.522,1697.707 -2.797,2465.729 201.941,3172.126 c 514.98,1126.319 1845.516,1621.908 2971.834,1106.928 388.227,-177.507 717.722,-462.139 949.765,-820.448 -590.532,553.099 -1662.86,460.662 -2578.07,-750.196 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M 2228.44,2012.453 C 1177.757,418.858 0.004,1268.113 0.004,2241.638 -0.421,2564.056 69.083,2882.732 203.723,3175.691 63.921,2515.895 822.012,2007.106 1527.9,2954.146 c 1024.964,1375.106 2030.828,1133.189 2593.604,507.516 180.738,-277.449 297.472,-591.64 341.739,-919.793 v 4.329 C 4221.58,3295.886 3155.108,3417.863 2228.44,2012.453 Z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91bfff",
    d: "M 2948.588,1299.435 C 2168.343,12.183 1179.03,128.048 509.302,817.893 179.168,1218.827 -0.925,1722.277 0.004,2241.638 c 70.029,-942.202 1209.584,-1597.924 2240.914,0 916.738,1422.217 2058.84,1051.702 2221.306,308.635 v -7.13 c 14.218,-101.209 20.265,-203.399 18.08,-305.579 v -101.86 c -396.998,284.188 -919.03,174.434 -1531.716,-836.269 z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4e1ff",
    d: "m 2953.936,1528.62 c 714.546,1148.723 1330.543,854.858 1527.896,609.121 -7.978,-171.708 -35.749,-341.922 -82.761,-507.261 -333.082,6.875 -410.75,-48.638 -738.483,-547.751 C 3159.692,315.216 2528.671,-202.996 1426.04,153.513 1068.788,293.635 753.238,522.671 509.302,818.912 1266.884,121.682 2196.354,310.887 2953.936,1528.62 Z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "m 3611.695,1181.533 c 326.715,499.877 525.596,525.342 787.376,448.947 C 4059.649,438.263 2818.011,-253.065 1625.795,86.357 c -67.6,19.245 -134.258,41.656 -199.755,67.157 984.983,-310.673 1683.486,260.251 2185.655,1028.019 z",
    id: "path12"
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_1_)",
    fillOpacity: 0.1,
    cx: 2240.918,
    cy: 2241.6379,
    r: 2240.9141,
    id: "circle27",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 0.2,
    d: "m 2240.918,26.189 c 1232.656,0 2233.911,995.526 2240.914,2228.181 v -12.732 C 4481.832,1004.017 3478.539,0.724 2240.918,0.724 1003.297,0.724 0.004,1004.017 0.004,2241.638 v 12.732 C 7.006,1021.715 1008.262,26.189 2240.918,26.189 Z",
    id: "path16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.2,
    d: "M 2240.918,4457.087 C 1008.262,4457.087 7.007,3461.561 0.004,2228.905 v 12.732 c 0,1237.623 1003.291,2240.914 2240.914,2240.914 1237.623,0 2240.914,-1003.291 2240.914,-2240.913 v -12.732 c -7.003,1232.655 -1008.259,2228.181 -2240.914,2228.181 z",
    id: "path18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleEarth);
export default __webpack_public_path__ + "static/media/googleEarth.e880e03d024bb70a6a86804e1181a760.svg";
export { ForwardRef as ReactComponent };